export class OperationTypesData {
  constructor(
    public origin: string,
    public destination: string,
    public trailerCount?: number,
    public current?: number
  ) {}
}
